import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mb-4 block" }
const _hoisted_2 = {
  key: 0,
  class: "flex text-danger py-2 rounded-lg mx-1"
}
const _hoisted_3 = { class: "align-middle text-xs" }


export default /*#__PURE__*/_defineComponent({
  props: {
    label: null,
    error: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", _hoisted_1, [
    _createElementVNode("p", {
      class: _normalizeClass(["text-xs pl-4 font-medium mb-1", __props.error ? 'text-danger' : 'text-gray-600'])
    }, _toDisplayString(__props.label), 3),
    _renderSlot(_ctx.$slots, "default"),
    (__props.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(__props.error), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})